import { c as _c } from "react-compiler-runtime";
import clsx from "clsx";
type ContainerProps = {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly variant?: "default" | "narrow" | "medium" | "wide" | "extraNarrow";
};
export default function Container(t0) {
  const $ = _c(5);
  const {
    children,
    className: t1,
    variant: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  t2 === undefined ? "default" : t2;
  let t3;
  if ($[0] !== className) {
    t3 = clsx("section-container", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}